import React, { FunctionComponent, ReactHTML, ReactHTMLElement } from 'react';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/components/infoClauseStyles';
import InfoIcon from '@material-ui/icons/Info';
import { BodyM, BodyS } from 'components/Typography/Typography';
const useStyles = makeStyles(styles);

interface InfoClauseType {
	message?: string;
	showBody?: boolean;
	bodyText?: any;
	Icon?: React.ReactElement;
}

const InfoClause: FunctionComponent<InfoClauseType> = ({ message = '', showBody, bodyText, Icon }) => {
	const classes = useStyles();

	return (
		<div className={classes.infoMessageContainer}>
			<div className={classes.infoiconWrapper}>{Icon ? Icon : <InfoIcon className={classes.infoicon} />}</div>
			<div className={classes.messageWrapper}>
				{!showBody && <BodyM disableMargin>{message}</BodyM>}
				{showBody && (
					<div className={classes.bodyWrapper}>
						{bodyText.map((body: any, id: number) => (
							<BodyS key={id}>{body?.text}</BodyS>
						))}
					</div>
				)}
			</div>
		</div>
	);
};

export default InfoClause;
